import React, { useState, useEffect, useCallback } from 'react'
import AchievementsAuthContext from './AchievementsAuthContext'
import { getToken, setToken, removeToken, getUserFromToken } from './token'

const AchievementsAuthProvider = ({ children }) => {
  const [user, setUser] = useState(null)
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    const storedUser = getUserFromToken()
    if (storedUser) {
      setUser({
        email: storedUser.email,
        name: storedUser.name,
        sub: storedUser.sub,
      })
    }
    setIsLoading(false)
  }, [])

  const login = useCallback((token, userData) => {
    setToken(token)
    setUser({
      email: userData.email,
      name: userData.name,
      sub: userData.sub || getUserFromToken()?.sub,
    })
  }, [])

  const logout = useCallback(() => {
    removeToken()
    setUser(null)
  }, [])

  const verifySession = useCallback(() => {
    const token = getToken()
    if (!token) {
      setUser(null)
      return false
    }
    return true
  }, [])

  const value = {
    isAuthenticated: user !== null,
    isLoading,
    user,
    login,
    logout,
    verifySession,
    getToken,
  }

  return (
    <AchievementsAuthContext.Provider value={value}>
      {children}
    </AchievementsAuthContext.Provider>
  )
}

export default AchievementsAuthProvider
